import { cloneElement, useId, useState, type ReactElement, type ReactNode } from "react";

import { cn } from "@/lib/utils";

interface SuggerimentoProps {
  titolo?: string;
  testo: ReactNode;
  children: ReactElement;
  className?: string;
  allinea?: "centro" | "destra" | "sinistra";
}

// Si apre al passaggio del mouse E al focus da tastiera. Il child deve essere
// un elemento singolo e focusabile; la descrizione aria si attacca a lui.
export function Suggerimento({
  titolo,
  testo,
  children,
  className,
  allinea = "centro",
}: SuggerimentoProps): JSX.Element {
  const id = useId();
  const [aperto, setAperto] = useState(false);
  return (
    <span
      className={cn("relative inline-flex", className)}
      onMouseEnter={() => setAperto(true)}
      onMouseLeave={() => setAperto(false)}
      onFocus={() => setAperto(true)}
      onBlur={() => setAperto(false)}
    >
      {cloneElement(children, { "aria-describedby": aperto ? id : undefined })}
      {aperto ? (
        <span
          role="tooltip"
          id={id}
          className={cn(
            "pointer-events-none absolute top-full z-50 mt-1.5 block w-[268px] rounded-md border border-line-2 bg-card px-2.5 py-2 text-left shadow-popover",
            allinea === "centro" && "left-1/2 -translate-x-1/2",
            allinea === "destra" && "right-0",
            allinea === "sinistra" && "left-0",
          )}
        >
          {titolo ? (
            <span className="mb-1 block text-micro font-semibold text-ink-3">
              {titolo}
            </span>
          ) : null}
          <span className="block text-xs font-normal normal-case leading-normal tracking-normal text-ink-2">
            {testo}
          </span>
        </span>
      ) : null}
    </span>
  );
}
